// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mwwa","name":"styles_name__2uY_1","phone":"styles_phone__1bfSJ"};